<div class="account-setting-complete mx-4 my-4 pb-5 modal-main">
  <div class="header pt-3 mt-1 mb-1 row pb-4">
    <div class="col-11 text-center">
      <h1 class="pt-2 pl-4 modal-title mtm-10 mb-0">
        {{ 'ACCOUNT_SETTING' | translate }}
      </h1>
    </div>
    <div class="col-1 text-center">
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
    <div class="w-100 d-flex flex-row justify-content-center align-items-center mt-4 pt-2">
      <h2 class="heading1 text-center">{{ SuccessMessage }}</h2>
    </div>

    <div
      class="w-100 d-flex flex-row justify-content-center align-items-center"
    >
      <img
        src="/assets/svg/ico-completed-check.svg"
        alt="completed account setting"
      />
    </div>

    <div
      class="modal-title w-100 d-flex flex-row justify-content-center align-items-center pb-5 completed position-relative"
    >
      <p>{{ 'COMPLETED' | translate }}</p>
    </div>
  </div>
</div>
